import { API_URL } from '../env';

export const logClientError = async ({ error, info, user, route }) => {
  try {
    const payload = {
      message: error?.message || 'Unknown client error',
      stack: error?.stack || null,
      component_stack: info?.componentStack || null,
      route,
      user_id: user?.sub || user?.email || null,
      user_email: user?.email || null,
      timestamp: new Date().toISOString(),
    };

    await fetch(`${API_URL}/api/logs/client`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (e) {
    // Logging must be non-blocking.
  }
};
